module.exports = __webpack_public_path__ + "static/media/social-media-management.858b70d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-media-management.svg
// module id = 325
// module chunks = 0